import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Text } from '../Text/index.js';

/**
 * A Link primitive.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/link#usage)
 * - [Props](https://blockparty.endpoint.com/components/link#props)
 * <br />
 *
 */
const Link = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    isDisabled,
    isExternal,
    onClick,
    as = 'a',
    dataTestId = 'link',
    ...rest
  } = _ref;
  const externalProps = isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : null;
  return /*#__PURE__*/React__default.createElement(Text, _extends({
    ref: forwardedRef,
    _hover: {
      textDecoration: 'underline'
    },
    "aria-disabled": isDisabled,
    as: as,
    color: "textPrimary",
    cursor: "pointer",
    "data-test-id": dataTestId,
    tabIndex: isDisabled ? -1 : undefined,
    textDecoration: "none",
    onClick: isDisabled ? e => e.preventDefault() : onClick
  }, externalProps, rest));
});
Link.displayName = 'Link';

export { Link };
